const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
 const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxMDI2LCJjb25ncmVzc0lkIjoxMzExLCJkYXRlIjoiMjAyMS0xMC0xM1QwNzoyOToxNS43ODJaIiwiaWF0IjoxNjM0MTEwMTU1fQ.w-ISyS3MlreixyfLIyx4_FJ9qoeKL6McGbV4EJPpk_A';
const PLANNER_API_URL = 'https://sgk2022.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxMDI3LCJjb25ncmVzc0lkIjoxMzExLCJkYXRlIjoiMjAyMS0xMC0xM1QwNzoyOTo1Mi4xOThaIiwiaWF0IjoxNjM0MTEwMTkyfQ.a2kQDUv-_eBMmqZGNsNtV2koGy2wVDtAWSpWpMTGJ5s';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1310;

const SUBMISSION_SYSTEM_URL = 'https://sgk2022.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 290;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  SESSION_GROUP_ID,
}